import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initKeycloak } from './components/auth/keycloak';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

initKeycloak()
  .catch((error) => {
    console.error('Keycloak init failed, rendering anyway:', error);
  })
  .finally(() => {
    root.render(
      // <React.StrictMode>
      <App />,
      // </React.StrictMode>,
    );
  });
